export const GRAPHQL_VARIABLES = {
  record: {
    type: 'bank',
    bank: {
      bsb: '000000',
      account: '0000000000',
      name: 'Tester'
    },
    direction: 'pay'
  }
};

export const QUERY = `
  mutation paymentMethodCreateOne ($record: AutoFilledCreateOnepaymentMethodsInput!){
    paymentMethodCreateOne (record: $record){
        recordId
        record {
            _id
            type
            bank{
                bsb
                account
                name
            }
            card{
                cardNo
                fzToken
            }
            companies
            direction
        }
    }
}
  `;
